<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight admire-apply">
        <div class="rule-step" v-if="step === 1">
            <div class="header">
                <div class="header-title">
                    申请开通
                    <span class="header-title-sec">申请开通游戏推广功能</span>
                </div>
            </div>
            <div class="content">
                <div class="rule-detail">
                    <h1 class="apply-bold main-color">
                        功能说明
                    </h1>
                    <p class="rule-part apply-bold">
                        智能财产是区块链运作时所需的天然要求。“数据文件”和“数字资产”。
                    </p>
                    <p class="rule-part">
                        数字资产是一个产品的数据化版本，包括具体的使用权利和通常的附带价值。没有权利，是不会被视作资产的，仅仅是“数字文件”。例如，数字资产包括一首歌、 一本书、一张照片或者一个商标。在比特币发明之前，把钱变成数字资产是行不通的，因为双发（或者双送）问题还没有被解决，这意味着欺诈行为。类似地，当你 将智能手机上的照片发送给别人，你仍然持有副本，那么你们俩都是图像的所有人。这在货币世界是不能被接受的，或者说具有真实价值或权利的资产不能被多个所 有者共享。
                    </p>
                    <p class="rule-part">
                        智能财产使得数字化资产概念走得更远，将资产和区块链联系起来从而使双发、双主人、双送的情况永不发生。如果你是这些数字资产的创造者或所有者，想象一下假如你以不可撤销的方式束缚住你的所有权（或权利），除非你自己决定将其转移或销售。这些全在自己的掌控中，而非他人。
                    </p>
                    <p class="rule-part">
                        你可能正在创造一个智能财产，就是那种能知道谁是拥有者的财产或事物。一个智能财产不一定非得是数字化产 品。可能是物理客观存在事物或者事情，通过显性的或隐性的与区块链相联系而变得“聪明”。有成千的事例，包括一把锁、一辆车、一台冰箱，甚至是你的房子。 通过关联加密签名，区块链可被用作审计数据库，并基于智能财产内容——智能财产将关联唯一的数字指纹。
                    </p>
                    <p class="rule-part">
                        现在想象这些功能中轻便、灵活和可发现性的因素，它们将成为去中心化点对点交易、金融交易或贸易的润滑剂。智能财产是区块链这列火车中的新形式数字化字节。
                    </p>
                    <p class="rule-part">
                        申请开通赞赏功能，需要绑定已实名认证的QQ、微信，且QQ钱包实名认证、微信实名认证的认证人必须与TGL平台上的认证作者信息相符（为同一人）。以上两个绑定的QQ号、微信号，将用于发放收到的赞赏金额，用户通过QQ赞赏的金额默认发到QQ钱包中，用户通过微信赞赏的金额默认发到微信零钱中。
                    </p>
                    <p class="rule-part">
                        赞赏费用发放周期，为T+3天，即当天收到的赞赏金额，将在3个自然日后自动发放，无需提现、无需申请。单作者每天发放的赞赏金额上限为1000元，超过部分将顺延至下个结算日发放。
                    </p>
                    <p class="apply-bold main-color">
                        赞赏功能使用
                    </p>
                    <p class="rule-part">
                        开通赞赏功能后，将会把作者名下2019年1月1日后，在自由投稿、活动投稿、王者视角上所投稿发布的内容生成专属的内容详情页（PC页面、H5页面）。在详情页面中，将会有赞赏功能按钮，所有查看到该页面的用户，均可使用赞赏功能，为该片内容的作者进行赞赏，赞赏金额由用户自主决定。
                    </p>
                    <p class="rule-part">
                        各位开通赞赏功能的作者可将上述内容详情页以链接/二维码的形式对外宣传（如发给好友、发到群中、转发朋友圈等等），让更多用户阅读到您的内容，以增加赞赏。此外，该页面的阅读量，也会计入自由投稿的流量补贴奖励中，更多的阅读量，也会给作者带来更多收益。
                    </p>
                    <p class="rule-part">
                        同样TGL平台也会有统一的内容页面用于推广、传播，对优质的作者、内容予以宣传，因此而带来的所有流量、赞赏金额，均归原创作者所有。
                    </p>
                    <p class="apply-bold main-color">
                        注意事项
                    </p>
                    <p class="rule-part">
                        作者必须遵守平台相应规定和服务条款，内容必须为原创内容，对于抄袭、搬运、违反国家法律法规的行为，平台一经发现查实，将对作者的赞赏功能及平台账号予以封停，相应赞赏金额，将予以冻结并退回原赞赏用户。
                    </p>
                </div>
                <div class="as-agreement">
                    <!-- 选中label添加ico-checkbox-checked- -->
                    <label class="f-inlineblock-middle ico ico-checkbox checkbox" :class="{'ico-checkbox-checked': agreeRule}" style="margin-right: 8px;">
                        <input class="g-input" type="checkbox" name="" checked="agreeRule" v-model="agreeRule">
                        <span></span>
                    </label>
                    <p class="f-inlineblock-top as-agreement-con"><span @click="agreeRule= !agreeRule">我已认真阅读并同意</span><a style="color: #409EFF;" href="https://tgl.qq.com/activity/#/center/notice/detail/83" target="_blank">《TGL平台赞赏功能使用条款》</a></p>
                </div>
                <div class="btn-wrap">
                    <a href="javascript:;" class="button" @click="next">下一步</a>
                </div>
            </div>
        </div>
        <div class="bind-step" v-if="step === 2">
            <div class="header">
                <div class="header-title">
                    填写资料
                    <span class="header-title-sec">腾讯游戏玩家创作联盟承诺所填实名认证信息</span>
                </div>
            </div>
            <div class="content">
                <div class="edit-part">
                    <el-form label-width="120px">
                        <el-form-item label="账号主体" required>
                            <el-radio-group v-model="params.userType">
                                <el-radio :label="1">个人</el-radio>
                                <el-radio :label="2">机构</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="渠道说明" required>
                            <el-input type="textarea" v-model="params.channelDesc" :rows="5" resize="none" placeholder="不少于15字，说明投放渠道，用户群信息等"></el-input>
                        </el-form-item>
                        <el-form-item label="个人说明" required>
                            <el-input type="textarea" v-model="params.userDesc" :rows="5" resize="none" placeholder="不少于15字，说明投放渠道，用户群信息等"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="btn-wrap" style="margin-top: 50px;">
                    <a href="javascript:;" class="button submit-loading" :class="{'submit-disabled': !getStatus()}" @click="submit" v-loading="loading" element-loading-spinner="el-icon-loading">申请开通</a>
                </div>
            </div>
        </div>
        <div class="success-step" v-if="step === 3">
            <div class="header">
                <div class="header-title">
                    申请开通
                    <span class="header-title-sec">腾讯游戏玩家创作联盟承诺所填实名认证信息</span>
                </div>
            </div>
            <!-- <div class="content" v-if="rewardInfo.status === 0">
                <img class="success-pic" src="~Assets/img/pages/v4/bind-success.png" alt="">
                <h2 class="success-tip">提交成功</h2>
                <p class="success-tip-sec">已成功提交审核，请等待审核，预计3~5个工作日</p>
            </div>
            <div class="content" v-if="rewardInfo.status === 10">
                <img class="success-pic" src="~Assets/img/pages/v4/bind-success.png" alt="">
                <h2 class="success-tip">提交成功</h2>
                <p class="success-tip-sec">已成功通过审核</p>
            </div>
            <div class="content" v-if="rewardInfo.status === 20">
                <img class="success-pic" src="~Assets/img/pages/v4/bind_error.png" alt="">
                <h2 class="success-tip">审核不通过</h2>
                <p class="success-tip-sec">{{rewardInfo.remark}}</p>
                <a href="javascript:;" class="button" @click="step = 2">返回</a>
            </div>
            <div class="content" v-if="rewardInfo.status === 30">
                <img class="success-pic" src="~Assets/img/pages/v4/bind_reject.png" alt="">
                <h2 class="success-tip">账号已封禁</h2>
                <p class="success-tip-sec">{{rewardInfo.remark}}</p>
            </div> -->
        </div>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/admire/apply.scss";
.edit-part {
    padding-top: 50px;
}
</style>
<style>
.submit-loading .el-loading-spinner {
    margin-top: -15px;
}
</style>

<script>
import {
    DownloadApply
} from 'Services/getData';
export default {
    data() {
        return {
            step: 1,
            agreeRule: false,
            loading: false,
            params: {
                userType: 1,
                channelDesc: '',
                userDesc: ''
            }
        }
    },
    components: {

    },
    computed: {

    },
    mounted() {

    },
    methods: {
        next() {
            if (!this.agreeRule) {
                this.$message.error('请先勾选协议');
            } else {
                this.step++;
                // this.$route.query.step = 2;
            }
        },
        getStatus() {
            return true;
        },
        async submit() {
            if(!this.params.channelDesc){
                this.$message.error('渠道说明不能为空')
                return ;
            }
            if(!this.params.userDesc){
                this.$message.error('个人说明不能为空')
                return;
            }
            this.loading = true;
            let res = await DownloadApply(this.params);
            this.loading = false;
            if (res.status === 200 && res.data.code === 0) {
                this.step++;
            }
        }
    }
}
</script>
